import React from 'react';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faFolderOpen, faThumbsUp } from "@fortawesome/free-solid-svg-icons";


export const TEMPLATE_PDF_ACTIONS = {
  LOAD_CURRENTLY_PDF: {
    value: 0,
    label: "Stay with the currently loaded PDF",
    icon: <FontAwesomeIcon icon={faThumbsUp} style={{marginRight: "10px", color: '#7F8487'}}/>
  },
  LOAD_FOR_THIS_TEMPLATE: {
    value: 1,
    label: "AUTO-LOAD a sample PDF from this template",
    icon: <FontAwesomeIcon icon={faBuilding} style={{marginRight: "10px", color: '#7F8487'}}/>
  },
  LOAD_PDF_FROM_FILE:  {
    value: 2,
    label: "Load PDF/image from file..",
    icon: <FontAwesomeIcon icon={faFolderOpen} style={{marginRight: "10px", color: '#7F8487'}}/>
  }
}

export const ALERT_MODALS = {
  PDF_VIRTUAL_FIELD_ALERT_MODAL: "PdfVirtualFieldAlertModal"
}